import React, { Component } from 'react';

class Footer extends Component {
  
  render() {
    const dt = new Date().getFullYear();
    return (
      <footer className="app-footer">
        &copy; {dt} MasteryPrep
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js